import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b3c3c2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_4 = {
  action: "/charge",
  method: "post",
  id: "payment-form"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-row" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "card-element" }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "card-errors",
    role: "alert"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  ref: "inviInput",
  type: "tel",
  style: {"border":"0px","color":"transparent","width":"0px","height":"0px","background":"transparent"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_signature_pad = _resolveComponent("signature-pad")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('checkout')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/bookings" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list_header, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('CheckoutPage.yourOrder')), 1)
                    ]),
                    _: 1
                  }),
                  ($setup.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_ion_spinner)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, [
                                  _createElementVNode("b", null, _toDisplayString($setup.booking.targetService), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            ($setup.booking.quotationFileLink)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  fill: "outline",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showBookingQuotation($setup.booking))),
                                  disabled: $setup.downloading
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('showQuotation')) + " ", 1),
                                    _withDirectives(_createVNode(_component_ion_spinner, null, null, 512), [
                                      [_vShow, $setup.downloading]
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            ($setup.isBookingPendingDeposit($setup.booking))
                              ? (_openBlock(), _createBlock(_component_ion_label, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString($setup.t('deposit')) + ": HK$ " + _toDisplayString($setup.numberWithCommas($setup.booking.calculatedDeposit)), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_ion_label, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString($setup.t('finalPayment')) + ": HK$ " + _toDisplayString($setup.numberWithCommas($setup.booking.calculatedFinalPayment)), 1)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }),
              ($setup.showFrame && $setup.isBookingPendingDeposit($setup.booking))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_ion_text, { color: "danger" }, {
                      default: _withCtx(() => [
                        _createElementVNode("b", null, _toDisplayString($setup.t('signConfirmQuote')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_signature_pad, {
                      modelValue: $setup.order.signatureDataURL,
                      onInput: $setup.onInput,
                      width: '100%',
                      height: 100,
                      customStyle: _ctx.customStyle,
                      saveType: _ctx.saveType,
                      saveOutput: _ctx.saveOutput,
                      ref: "signaturePad"
                    }, null, 8, ["modelValue", "onInput", "customStyle", "saveType", "saveOutput"]),
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: "medium",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.clearSignature()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: $setup.refresh
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString($setup.t('resetSignature')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_radio_group, {
                    modelValue: $setup.order.paymentMethod,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.order.paymentMethod) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list_header, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('CheckoutPage.paymentInfo')), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paymentMethods, (method) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: method.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_radio, {
                              slot: "start",
                              value: method.value
                            }, null, 8, ["value"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(method.key), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_icon, {
                              icon: method.icon,
                              slot: "end"
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("form", _hoisted_4, _hoisted_6, 512), [
                [_vShow, $setup.order.paymentMethod == 'card']
              ]),
              _createElementVNode("input", _hoisted_7, null, 512),
              _createVNode(_component_ion_button, {
                color: "success",
                class: "submit-btn",
                expand: "block",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.submitOrder($setup.booking, $setup.order)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('CheckoutPage.confirmPayment')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}